var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-tab"},[_c('v-tabs',{attrs:{"hide-slider":"","mandatory":""}},[_vm._t("tabs"),_c('v-tabs-items',{attrs:{"vertical":""}},[_vm._t("tabs-content")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }